import type { AccountsReceivablesFormSchema } from './schemas';

export const defaultValues: Readonly<AccountsReceivablesFormSchema> = {
  id: -1,
  amount_original: 0,
  balance_due: 0,
  invoice: null,
  total_paid: 0,
  current_due: 0,
  account_receivable_payments: [],
} as const;
